import { email, mobile } from '@/validations/components'

export const validations = {
    email,
    mobile
}
